import { CommHistoryService } from '@weave/schema-gen-ts/dist/schemas/comm/history/v1/history_service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaCommHistoryV1Service = bindHTTP(CommHistoryService);
export const serviceName = 'comm-history-v1' as const;
